import SyntheseEntityConsistanceController from './syntheseentities.consistance.controller';

export default {
    template: require('./syntheseentities.consistance.html'),
    controller: SyntheseEntityConsistanceController
};
